import {
  UPDATE_MENU_MISSION_REQUEST,
  UPDATE_MENU_MISSION_SUCCESS,
  UPDATE_MENU_MISSION_ERROR,
  RESET_MENU_MISSIONS,
  RESET_EDIT_MENU_MISSION,
  GET_MENU_MISSION_FROM_LIST,
  REMOVE_MENU_MISSION_SUCCESS,
  REMOVE_MENU_MISSION_ERROR,
  FETCH_MENU_MISSIONS_REQUEST_V2,
  FETCH_MENU_MISSIONS_ERROR_V2,
  FETCH_MENU_MISSIONS_SUCCESS_V2,
  ALL_PROFILES,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    all: [],
    records: [],
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_MENU_MISSIONS_REQUEST_V2:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_MENU_MISSIONS_SUCCESS_V2:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_MENU_MISSIONS_ERROR_V2:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case UPDATE_MENU_MISSION_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_MENU_MISSION_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
          updated: true,
          removed: false,
        },
      }

    case UPDATE_MENU_MISSION_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: action.payload,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case RESET_MENU_MISSIONS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: null,
        },
      }

    case RESET_EDIT_MENU_MISSION:
      return {
        ...state,
        edit: {
          isUpdating: false,
          error: null,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case GET_MENU_MISSION_FROM_LIST:
      const { index } = action
      const record = state.list.records[index]

      return {
        ...state,
        get: {
          ...state.get,
          record,
          error: null,
          isFetching: false,
        },
      }

    case REMOVE_MENU_MISSION_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: null,
          updated: false,
          removed: true,
        },
      }

    case REMOVE_MENU_MISSION_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          removed: false,
        },
      }

    case ALL_PROFILES:
      return {
        ...state,
        list: {
          ...state.list,
          all: action.payload,
        },
      }

    default:
      return state
  }
}

export default record
